import React from 'react';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Theme } from '@mui/material/styles';
import { Incident, TEMPERATURE_THRESHOLDS } from '../../types';
import { getTemperatureColor } from '../../styles';
import {
  noDataTextStyles,
  temperatureCellContainerStyles,
  temperatureCellTextStyles,
} from './styles';

interface TemperatureCellProps {
  params: GridRenderCellParams<Incident, number>;
  theme: Theme;
}

const TemperatureCell: React.FC<TemperatureCellProps> = ({ params, theme }) => {
  const value = params.value;

  if (!value || value === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Typography sx={noDataTextStyles} color='textSecondary'>
          No data
        </Typography>
      </Box>
    );
  }

  const color = getTemperatureColor(value, theme);
  const isIncident = value > TEMPERATURE_THRESHOLDS.INCIDENT;

  return (
    <Box sx={temperatureCellContainerStyles(color)}>
      <Typography sx={temperatureCellTextStyles(color, isIncident)}>
        {value.toFixed(1)}°C
      </Typography>
    </Box>
  );
};

TemperatureCell.displayName = 'TemperatureCell';

export default TemperatureCell;
